import AutocloneForm from './AutocloneForm';

export default AutocloneForm;
